'use strict';

let PhoneNumberUtil = require('google-libphonenumber').PhoneNumberUtil;
let phoneUtil = null;

function isValid(value, region) {
    if (!/^[\d\s\+-]*$/.test(value)) {
        return false;
    }

    if (!phoneUtil) {
        phoneUtil = PhoneNumberUtil.getInstance();
    }

    try {
        let number = phoneUtil.parse(value, region);
        return phoneUtil.isPossibleNumber(number) && phoneUtil.isValidNumber(number);

    } catch (e) {
        return false;
    }
}

class Validator {
    construct() {
        this.message = '';
        this.region = 'CZ';
    }

    validate(value) {
        let errors = [];

        if (FpJsFormValidator.isValueEmty(value)) {
            return errors;
        }

        if (!isValid(value, this.region)) {
            errors.push(this.message.replace('{{ value }}', FpJsBaseConstraint.formatValue(value)));
        }

        return errors;
    }
}

window.AdFinanceFrontendBundleFormValidatorPhoneNumber = Validator;



// WEBPACK FOOTER //
// ./app/Resources/assets/js/lib/formValidator/adfinance.phoneNumber.js